import React, { Component } from "react";

import { Link } from "gatsby";
import PropTypes from "prop-types";
import { isImageSquare } from "../../util/isImageSquare";

class StackCard extends Component {
  render() {
    const { title, acf, categories, uri } = this.props.cardData.node;
    const imageHeight = acf?.iconColor?.mediaDetails?.height;
    const imageWidth = acf?.iconColor?.mediaDetails?.width;
    return (
      <>
        <DesktopCard
          {...{ title, acf, categories, uri, imageHeight, imageWidth }}
          {...this.props}
        />
        <MobileCard
          {...{ title, acf, categories, uri, imageHeight, imageWidth }}
          {...this.props}
        />
      </>
    );
  }
}

const ConditionalWrapper = ({ condition, wrapper, children }) => 
  condition ? wrapper(children) : children;

const DesktopCard = ({
  title,
  acf,
  categories,
  uri,
  imageHeight,
  imageWidth,
  renderSmallCard=true
}) => {
  return (
    
      <ConditionalWrapper
        condition={!acf.tenjinNoContent}
        wrapper={children => <Link className={`${renderSmallCard ? "hidden sm:flex sm:max-w-none": "flex"}`} to={uri}>{children}</Link>}
        
      >
        <div className={`${renderSmallCard ? "hidden sm:flex sm:max-w-none": "flex"}`}>

          <div className={`h-72 overflow-hidden  w-64 rounded-2xl ${acf.tenjinNoContent !== true ? " shadow-xl hover:shadow-2xl" :""}`} >
            <div className={"h-card h-full pb-6 pt-4 px-4 relative"}>
              <div className="relative flex flex-row justify-end h-6 space-x-1">
                
                {acf?.tenjinUpcomingContent && (
                  <div className="relative z-50 px-2 text-white bg-red-800 rounded w-content bg-pill-upcoming">
                    <p className="text-sm font-medium">Upcoming</p>
                  </div>
                )}
                {acf?.tenjinNewContent && (
                  <div className="relative z-50 px-2 text-white bg-red-800 rounded w-content bg-pill-new">
                    <p className="text-sm font-medium">New</p>
                  </div>
                )}
              </div>
              <div className={`absolute top-0 left-0 right-0 z-20 flex flex-col justify-between h-full ${acf.tenjinNoContent !== true ? "bg-white " :"bg-gray-100"}`}>
                <div className={`flex p-5 m-auto border-b-1 mt-14 ${acf.tenjinNoContent !== true ? "bg-white " :"bg-gray-100"}`}>
                  <img
                    className={`block ${
                      isImageSquare(imageWidth, imageHeight) ? "w-25	h-25" : "h-25"
                    }`}
                    src={
                      acf?.iconColor?.sourceUrl
                        ? acf.iconColor.sourceUrl
                        : "https://via.placeholder.com/64x64/?text=no+image"
                    }
                    alt={acf?.iconAlt ?? title}
                  />
                </div>
                <div className="absolute px-8 bottom-4">
                  <h4 className="text-xl text-2xl font-black leading-8 tracking-wide text-font-primary ellipsis-title-2 opacity-80">
                    {title} 
                  </h4>
                  <h6>{categories?.nodes && categories?.nodes[0]?.name}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ConditionalWrapper>
  );
};

const MobileCard = ({
  title,
  acf,
  categories,
  uri,
  imageHeight,
  imageWidth,
  renderSmallCard=true
}) => {
  return (
    <ConditionalWrapper
      condition={!acf.tenjinNoContent}
      wrapper={children => <Link to={uri} className={`${renderSmallCard ? "sm:hidden max-min-small-stack-card-width truncate": "hidden"}`}>{children}</Link>}
      
    >
  
      <div className="flex flex-col items-center px-3 py-3 overflow-hidden sm:hidden max-min-small-stack-card-width max-height-max-content">
        <div
          className="relative flex items-center justify-center p-8 mb-3 bg-white border rounded-full max-min-small-stack-card-width overflow-ellipsis"
        >
          {acf?.tenjinUpcomingContent && (<div className="absolute top-0 z-10 px-2 text-white bg-red-800 rounded right-0 w-content bg-pill-upcoming">
            <p className="text-sm font-medium">Upcoming</p>
          </div>
          )}
          {acf?.tenjinNewContent && (<div className="absolute top-0 z-10 px-2 text-white bg-red-800 rounded right-0 w-content bg-pill-new">
            <p className="text-sm font-medium">New</p>
          </div>
          )}
          <img
            src={
              acf?.iconColor?.sourceUrl
                ? acf.iconColor.sourceUrl
                : "https://via.placeholder.com/64x64/?text=no+image"
            }
            alt={acf?.iconAlt ?? title}
            className={`w-12 h-12 ${
              isImageSquare(imageWidth, imageHeight) ? "w-12 h-12" : "h-12"
            }`}
          />
        </div>
        <p className="max-min-small-stack-card-width text-center truncate">{categories?.nodes && categories?.nodes[0]?.name}</p>
        <p className="text-lg font-black leading-8 tracking-wide text-font-primary truncate max-min-small-stack-card-width text-center">
          {title}
        </p>
      </div>
    </ConditionalWrapper>
  );
};

StackCard.propTypes = {
  cardData: PropTypes.object,
};

StackCard.defaultProps = {
  cardData: ``,
};

export default StackCard;
